import { Video23Player } from '@pm2/media-component';
import { PlayIcon } from '@ui/kit/icons';
import { checkboxMediaInput } from '@utils/component-framework';
import { usePageContext } from '../../../../context.js';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { useInputState } from '../../hook.use-input-state.js';
import { MediaBox } from '../atom.media-box/_media-box.js';
import { aspectRatio, box, printWrapper, printThumbnail, printPlayIcon } from './input.video.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function VideoInput(props) {
  const pageContext = usePageContext();
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => checkboxMediaInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const onChange = () => {
    update(props.taskEntryKey, props.node.id, {
      type: "checkbox-media",
      markedAsCorrectAnswer: !inputEntry?.markedAsCorrectAnswer
    });
  };
  const baseState = useInputState(props.node, inputEntry);
  const state = (() => {
    if (baseState === "incorrect" && !inputEntry?.markedAsCorrectAnswer && props.node.correctAnswer) {
      return "should-have";
    }
    return baseState;
  })();
  const aspectAsScalar = props.node.twentyThreeVideo.height && props.node.twentyThreeVideo.width ? props.node.twentyThreeVideo.width / props.node.twentyThreeVideo.height : undefined;
  return /*#__PURE__*/jsx("div", {
    style: aspectRatio.__override(aspectAsScalar),
    children: /*#__PURE__*/jsx(MediaBox, {
      state: state,
      className: box,
      checked: !!inputEntry?.markedAsCorrectAnswer,
      onChange: onChange,
      orientation: props.orientation,
      theme: "squared",
      children: pageContext === "print" ? /*#__PURE__*/jsxs("div", {
        className: printWrapper,
        children: [/*#__PURE__*/jsx("img", {
          className: printThumbnail,
          src: props.node.twentyThreeVideo.thumbnail,
          alt: ""
        }), /*#__PURE__*/jsx("div", {
          className: printPlayIcon,
          children: /*#__PURE__*/jsx(PlayIcon, {})
        })]
      }) : /*#__PURE__*/jsx(Video23Player, {
        photoId: props.node.twentyThreeVideo.id,
        token: props.node.twentyThreeVideo.token,
        aspectRatio: props.node.twentyThreeVideo.aspectRatio ?? undefined,
        title: undefined,
        caption: undefined,
        showSubtitlesByDefault: false
      })
    })
  });
}

export { VideoInput };
//# sourceMappingURL=input.video.js.map
